import { memo } from 'react';
import VpnKeyOffOutlinedIcon from '@mui/icons-material/VpnKeyOffOutlined';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { Button } from 'root/src/client/v2/common/components/ui/button';
// Shown when a creator tries to take a dare on a drop whose initial product (the join key) is
// depleted. The accept endpoint puts them on the restock waitlist as it turns them away, so there is
// nothing left to do here but say so. This replaced an "accept anyway" button that let creators join
// a drop which had nothing left to give them.
export const RedesignNoInitialKeysModal = memo(() => {
    const modal = useRedesignModal();
    return (<RedesignModalShell className="sm:max-w-md">
			<div className="flex w-full flex-col items-center gap-3 text-center">
				<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-amber/30 bg-neon-amber/10">
					<VpnKeyOffOutlinedIcon sx={{ fontSize: 24 }} className="text-neon-amber"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">Keys are gone</h2>
				<p className="text-sm text-muted-foreground">
					Every key for this drop has been claimed, so the dare could not be created.
				</p>
				<p className="text-xs italic text-muted-foreground">
					You are on the waitlist. We will email you the moment the brand adds more.
				</p>
			</div>

			<Button variant="brand" onClick={modal.hide} className="w-full rounded-lg text-sm">
				Got it
			</Button>
		</RedesignModalShell>);
});
